import { MatDialog } from '@angular/material/dialog';
import {
  loadCurrentCustomerActionError,
  loadCurrentCustomerActionSuccess,
  retrieveCurrentCustomerAction,
  updateCurrentCustomerAction,
  updateCurrentCustomerActionError,
} from '../actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService, Customer, CustomerApiService } from '@fc-core';
import { NotificationService } from '@fc-core/services/notification.service';
import { of } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';
import { getErrorMessage } from '@fc-core/services/notification.utils';

@Injectable()
export class CurrentCustomerEffects {
  loadCurrentCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(retrieveCurrentCustomerAction),
      share(),
      switchMap(() => {
        return this.customerApi
          .load(this.auth.tokenData?.customer_id ?? '')
          .pipe(
            map((customer: Customer) => {
              return loadCurrentCustomerActionSuccess({ customer });
            }),
            catchError((err) => {
              return of(loadCurrentCustomerActionError({ err }));
            }),
          );
      }),
    ),
  );
  updateCurrentCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCurrentCustomerAction),
      share(),
      switchMap((action) => {
        return this.customerApi.updateCustomerSettings(action.customer).pipe(
          map(() => {
            this.notifications.showSuccess('Your company has been updated.');
            this.dialog.closeAll();
            return retrieveCurrentCustomerAction();
          }),
          catchError((err) => {
            this.notifications.showError(getErrorMessage(err));
            return of(updateCurrentCustomerActionError({ err }));
          }),
        );
      }),
    ),
  );

  constructor(
    private customerApi: CustomerApiService,
    private actions$: Actions,
    private auth: AuthService,
    private dialog: MatDialog,
    private notifications: NotificationService,
  ) {}
}
